package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_options

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.price_level.PriceLevelItem
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_surcharge_in_house.SurchargeContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.dom.Col

@Composable
fun TemplateOptionContent(
    selectedIndex: Int?,
    countryId:String,
    getPriceLevels: () -> Unit,
    priceLevelList: List<String?>?,
    updatePriceLevel: (Int) -> Unit,
    surchargePercent: List<Int?>?,
    updateSurcharge: (String, List<Int?>)->Unit,
)
{
    LaunchedEffect(Unit){
        getPriceLevels()
    }

    val indexedPriceLevelList = priceLevelList?.mapIndexed { index, value ->
        PriceLevelItem(value, index)
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            ),
    )
    {
        Row(
            Modifier
                .autoResponsiveness()
                .fillMaxWidth()
        )
        {
            Column(
                modifier = Modifier
                    .margin(right = Dimen.largePadding)
            ) {
                MediumContentTitle(
                    title = Strings.current().priceLevels
                )

                DropDownItem(
                    modifier = Modifier,
                    itemWidth = Dimen.mediumEditTextWidth,
                    options = indexedPriceLevelList ?: listOf(),
                    label = Strings.current().priceLevels,
                    selectedItem = if (selectedIndex != null)
                        indexedPriceLevelList?.find { it.index == selectedIndex }
                    else null,
                    displayText = { item ->
                        if(item is PriceLevelItem ){
                            item.value ?: (LanguageManager.getCurrentStrings().price
                                    + " " + item.index.toString())
                        } else  ""

                    },
                    onOptionClick = { item ->
                        if(item is PriceLevelItem){
                            updatePriceLevel(item.index)
                        }

                    },
                )
            }


            SurchargeContent(
                surchargeList = surchargePercent?: listOf(),
                title = Strings.current().surchargePercent,
                countryId = countryId,
                updateSurcharge = {
                    updateSurcharge(
                        ApiUtils.Field.surchargePercent,
                        it
                    )
                }
            )



        }
    }




}